<template>
  <Row>
    <div class="title">{{ this.$t("产品项目号")}}:{{ this.$route.query.project_code }} </div>
      <packageTable
        ref="contentBaseRef"
        class="contentBaseRef"
        :columnsData="columnsheader"
        :tableData="tableDataList"
        :reduceheight="reduceheight"
        :loading="tableLoading"
        :border="true"
        :tabletotallen="getPageTotal"
        :showSearchBtn="false"
        :tablePageSize="reqBase.page_size"
        @pageonChange="pageonChange"
        @pageSizeChange="pageSizeChange"
        @refreshBtn="init"
        @getSelect="getSelectList"> 
          <template slot="headLeft">
            <Form ref="formInline" :model="form_filter" class="tableHeaderForm" @keydown.enter.native="search" inline>
              <!-- <FormItem label="所在服务器">
                  <Input type="text" style="width:120px" v-model="form_filter.country_code" placeholder="经销商筛选"/>
              </FormItem>  -->
             
              <!-- <FormItem label="产品型号">
                  <Input type="text" style="width:120px" v-model="form_filter.model_code" placeholder="产品型号筛选"/> 
                </FormItem> -->
              <FormItem :label="this.$t('dictmenu.protocolname')">
                 <Input type="text" style="width:120px" v-model="form_filter.protocol_name" :placeholder="this.$t('dictmenu.protocolnamefilter')"/> 
                </FormItem>  
              <FormItem class="reduceFromMarginLeft">
                  <Button v-for="(item,index) in topButtonList" :type="item.type"
                          style="margin-right: 5px;" @click="item.method" :key="index">{{item.name}}</Button>
              </FormItem>
            </Form>
          </template>
          <template slot="headRight">
              <!-- <Tooltip v-for="(item,index) in topButtonList1" :key="index"  :content="item.name" placement="bottom">
                <Button  
                    :type="item.type"      
                    style="margin-right: 5px;" 
                    @click="item.method" 
                    :key="index" 
                    :icon="item.icon"></Button>
            </Tooltip> -->
          </template>
          <template slot="headRight">
              <Tooltip v-for="(item,index) in topButtonList1" :key="index"  :content="item.name" placement="bottom">
                <Button  
                    :type="item.type"      
                    style="margin-right: 5px;" 
                    @click="item.method" 
                    :key="index" 
                    :icon="item.icon"></Button>
            </Tooltip> 
          </template>
      </packageTable>
  </Row>
</template>
<script>
import packageTableMixins from '@/mixins/packageTableMixins'
import customDetails from './components/customDetails.vue'
 import uploadCom from "./components/uploadCom"
import addCom from './components/addCom'  
import config from '@/config/index'
 
import {dict_list,set_default,dict_add,dict_update,dict_del,daoru,daochu,get_downloadtoken} from '@/api/jingxiaoshang'
export default {
name: "MechanismManage",
mixins: [packageTableMixins], 
data() { 
  return {   
    product_type_code:"",
    xieyi_name:"",
    country_codeData: [
      { "value":"xciot-prod-cnsz", "name": "中国区" },
      {"value":"xciot-prod-hk","name":"香港区"},
      { "value": "xciot-prod-eu", "name": "欧洲区" },
      {"value":"xciot-prod-us2","name":"美国区"}
    ], 	
    country_code2Data: [
    { "value":"86", "name": "中国" },
    ],
    form_filter:{
      protocol_name:"",
      model_code: ""
    },
    //共用的查询与重置
    topButtonList:[
      {
        name:this.$t("query"),
        type:'primary',
        method:this.search
      },
      {
        name:this.$t("reset"),
        type:'error',
        method:this.reset
      }
    ],
    //共用的右侧添加按钮
    topButtonList1: [
    {
        name:this.$t('add'),
        icon:'ios-add',
        type:'primary',
        method:this.add
      },
    {
          name:this.$t('import'),
          icon:'ios-cloud-upload',
          type:'primary',
          method:this.daoru
        },
       {
          name:this.$t('export'),
          icon:'ios-cloud-download',
          type:'primary', 
          method:this.daochu
        },
   
      // {
      //   name:this.$t('refresh'),
      //   icon:'ios-refresh',
      //   type:'primary',
      //   method:this.init
      // }
    ],
    reqBase: {
      page:1,
      page_size:15
    },
    status: true,//是否企业认证
    tableDataList: [],
    getPageTotal: 0,
    operationButtonList:[
              {
                name:this.$t('edit'), 
                type:'primary',
                icon:'',
                method:this.edit
      },
      {
                name:this.$t('delete'),
                type:'primary',
                icon:'',
                method:this.del
      },
      // {
      //           name:this.$t('details'),
      //           type:'primary',
      //           icon:'',
      //           method:this.details
      //         },
          
    ],
    // operationButtonList1:[
    //   {
    //     name:this.$t('operationModule.submitReview'),
    //     type:'primary',
    //     icon:'',
    //     method:this.submitReview
    //   },
    // ],
    columnsheader: [
      // {
      //   align: 'center',
      //   title: '产品型号',
      //   minWidth:120,
      //   key: 'model_code',
      // },
      {
        align: 'center',
        title: this.$t('dictmenu.protocoltype'),
        minWidth:120, 
        key: 'protocol_type_name',
      },
      {
        align: 'center',
        title: this.$t('dictmenu.protocolnumber'),
        minWidth:120,
        key: 'protocol_number',
      },
      {
        align: 'center',
        title: this.$t('dictmenu.protocolname'),
        minWidth:120,
        key: 'protocol_name',
      },
      {
        align: 'center',
        title: this.$t('dictmenu.invertertype'),
        minWidth:120,
        key: 'inverter_type_name',
      },
      {
        align: 'center',
        title: this.$t('dictmenu.creationtime'),
        minWidth:120,
        key: 'addtime',
      },
     
     
      {
        align: 'center',
        title: this.$t('operation'),
        minWidth:150,
        key: 'Operating',
        render: (h, { row }) => {
          let arr=[]
          //this.operationButtonList = [];
          let list=this.operationButtonList[0];
         
             //编辑
            
             arr.push(h('Button', {
                    style: {marginLeft: '5px',marginBottom:'3px'},
                    props: {
                      type: list.type,
                      size: list.size ? list.size : 'small'
                    },
                    on: {
                      click: () => {
                        this.edit(row)
                      }
                    }
            }, list.name));
           
            //删除
             list=this.operationButtonList[1];
            arr.push(h('Button', {
                    style: {marginLeft: '5px',marginBottom:'3px'},
                    props: {
                      type: list.type,
                      size: list.size ? list.size : 'small'
                    },
                    on: {
                      click: () => {
                        this.del(row)
                      }
                    }
            }, list.name));

            //  //查看
            //  list=this.operationButtonList[2];
            // arr.push(h('Button', {
            //         style: {marginLeft: '5px',marginBottom:'3px'},
            //         props: {
            //           type: list.type,
            //           size: list.size ? list.size : 'small'
            //         },
            //         on: {
            //           click: () => {
            //             this.details(row)
            //           }
            //         } 
            // }, list.name));
 
 
          return h('div',{style:{padding:'5px'}},arr)
         // return h('div',arr)
        }
      },
    ],
  }
},
props:{
  reducehe:{},
  code:{}
},
components: {
  customDetails
},   
computed: {

},
  methods: {
    /**
     * 导入
     */
     daoru(){
      let vm=this;
        let config={
          loading:true,
          width:600,
          render:(h)=>{     
            return h('div',[
              h('h3',this.$t('import')),
              h(uploadCom,{
                ref:'uploadCom',
                props:{
                  edit: false,
                  _vm:vm
                }
              })
            ])
          },
          onOk:function(){
            let _this=this;
            let obj=this.$refs.uploadCom;
            obj.checkForm().then(res=>{
              if(res){
                //提交请求
                let formModel =obj.formModel;
                let formData = new FormData()
                formData.append('filename', formModel.filename)
                formData.append('xieyi_code', vm.$route.query.xieyi_code)
                formData.append('product_code',vm.$route.query.product_code)
                daoru(formData).then(res=>{
                  if(res.result===0){ 
                    vm.$Message.success(res.errorMsg);
                    vm.$Modal.remove();
                    vm.init();
                  }else{
                    vm.$Message.error(res.errorMsg,5);
                    _this.buttonLoading = false;
                  }
                });
              }else{
                _this.buttonLoading=false;
              }
            });
          }
        };
        this.$Modal.confirm(config);
    },
    daochu() { 
      let vm = this
      let config = {
        title: this.$t('export'),
        loading: true,
        content: this.$t('dictmenu.sureexport'),
        onOk: function () {
          let _this = this
          // vm.$store.dispatch("user/handleget_downloadtoken", { type: "did" })
          //   .then((res) => {
                 
            get_downloadtoken().then(res => { 
            // console.log(res.result) 
            //     return
               _this.buttonLoading = false
               if (res.result === 0) {
               
                let downloadtoken = res.body.downloadtoken
                let params =
                  "?type=1&downloadtoken=" +
                   downloadtoken +"&xieyi_code="+vm.$route.query.xieyi_code+"&product_code="+vm.$route.query.product_code
                 
                window.open("http://pcphp.test.xcthings.com/index.php/admin/dict/daochu" + params)
                vm.$Modal.remove()
              } else {
                vm.$Message.error(res.errorMsg)
              }
            }) 
        } 
      }
      this.$Modal.confirm(config)
    },
     
 /**
     * 删除
     */
     del(row){
      let vm=this;
        this.$Modal.confirm({
        title:this.$t('delete'),
        content:this.$t('dictmenu.suredelete')+row.protocol_type_name+row.protocol_number+this.$t('dictmenu.ma'),
        loading:true,
        onOk:function(){
          let _this=this; 
          dict_del({dict_code:row.dict_code}).then(res => {
            let msg=res.errorMsg;
            if (res.result === 0) {
                let msg=res.errorMsg;
                vm.$Message.success(msg);
                vm.$Modal.remove();
                vm.init()
            } else {
              vm.$Message.error(msg); 
              _this.buttonLoading = false;
            }
          });
        }
      })
    },
    details(row){
        let vm = this;
        let config = {
          okText:"关闭", 
          loading: true,
          width: 600,
          render: (h) => {
            return h('div', [
              h('h3', this.$t('viewdetails')),
              h(addCom, {
                ref: 'addCom',
                props: {
                  _vm: vm,
                  $store:vm.$store,
                  edit:true,
                  hasDetails: true,
                  setData: row
                }
              })
            ])
          },
          onOk: function () {
            let _this = this;
            this.$Modal.remove();
          }
        };
        this.$Modal.success(config);
 
  },
    add(){
      let vm = this;
      let is_huise = false
      console.log("asdf",vm.product_type_code)
      if (vm.product_type_code == "222" || vm.product_type_code == "333") {
        is_huise=true
       //  alert(11)
      }
       
        let config = {
          loading: true,
          width: 500,
          render: (h) => {
          return h('div', [
              h('div', { style: { display: 'flex', justifyContent: 'space-between' } }, [
              h('h3', { style: { width: '100%', paddingBottom: '5px' } }, this.$t('dictmenu.addinverterdict')),
              h('icon', {
                  props: { type: 'md-close', size: '16' },
                  style: {
                      cursor: 'pointer'
                  },
                  on: {
                      'click': evt => {
                          vm.$Modal.remove()
                      }
                  }
              })
              ]),
              h('Divider',{
                  style:{
                      margin:'8px 0'
                  }
              }),
              h(addCom, {
                  ref: 'addCom',
                  props: {
                      _vm: vm,
                      $store:vm.$store,
                      edit:false,
                      parent_code:'0',
                      parent_name: '无',
                      is_huise: is_huise,
                      product_type_code:vm.product_type_code
                  }
              })
          ])
          },
          onOk: function () {
            let _this = this;
            let obj = this.$refs.addCom;
            obj.checkForm().then(res => {
              console.log("add打印",vm.$route.query.xieyi_code)
           //   return
            if (res) { 
              dict_add({...obj.formModel,xieyi_code:vm.$route.query.xieyi_code,product_code:vm.$route.query.product_code}).then(res => {
              let msg=res.errorMsg;
              if (res.result === 0) {
                let msg=res.errorMsg;
                vm.$Message.success(msg);
                vm.$Modal.remove(); 
                vm.init()
              } else {
              vm.$Message.error(msg);
                _this.buttonLoading = false;
              }
            });
            } else {
                _this.buttonLoading = false;
            }
          });
          }
        };
        this.$Modal.confirm(config);
      },
    edit(row) {
      console.log('a', row)
        
        let vm=this;
        let is_huise = false
      if (vm.product_type_code == "222" || vm.product_type_code == "333") {
        is_huise=true
      }
      let config = {
          loading:true,
          width:500,
          render:(h)=>{
            return h('div', [
              h('div', { style: { display: 'flex', justifyContent: 'space-between' } }, [
              h('h3', { style: { width: '100%', paddingBottom: '5px' } },this.$t('dictmenu.editiverterdict')),
              h('icon', {
                  props: { type: 'md-close', size: '16' },
                  style: {
                      cursor: 'pointer'
                  },
                  on: {
                      'click': evt => {
                        vm.$Modal.remove()
                      }
                  }
              })
              ]),
              h('Divider',{
                  style:{
                      margin:'8px 0'
                  }
              }),
              h(addCom,{
                ref:'addCom',
                props:{
                  edit:true,
                  $store:vm.$store,
                  _vm: vm,
                  setData: row,
                  is_huise: is_huise,
                  product_type_code:vm.product_type_code
                }
              })
            ])
          },
          onOk: function () {
            let _this = this;
            let obj = this.$refs.addCom;
            obj.checkForm().then(res => {
              if (res) {
                //let { area_name, desc, area_code } = obj.formModel

                dict_update({...obj.formModel,'xieyi_code':row.xieyi_code,'product_code':vm.$route.query.product_code}).then(res => {
                let msg=res.errorMsg;
                if (res.result === 0) {
                  let msg=res.errorMsg;
                  vm.$Message.success(msg);
                  vm.$Modal.remove();
                  vm.init()
                } else {
                vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
              } else {
                  _this.buttonLoading = false;
              }
            });
          }
        };
        this.$Modal.confirm(config);
    },
   
    set_default(row) {
      // console.log(row)
      let vm=this;
        this.$Modal.confirm({
        title:'设为默认',
        content:'您确定要设置'+row.protocol_name+'为默认吗？',
        loading:true,
        onOk:function(){
          let _this=this;
          set_default({dict_code:row.dict_code}).then(res => {
            let msg=res.errorMsg;
            if (res.result === 0) {
                let msg=res.errorMsg; 
                vm.$Message.success(msg);
                vm.$Modal.remove();
                vm.init()
            } else {
              vm.$Message.error(msg); 
              _this.buttonLoading = false;
            }
          });
        }
      })
   
    },
 
    init() { 
     // this.get_type();
    this.tableLoading = true;
    dict_list({...this.reqBase,"xieyi_code":this.$route.query.xieyi_code,'product_code':this.$route.query.product_code}).then(res => {
      this.tableLoading = false;
      this.tableDataList = [];     
      if (res.result === 0) {
        this.xieyi_name = res.body.xieyi.xieyi_name
        this.product_type_code=res.body.xieyi.product_type_code
        this.tableDataList = res.body.list || [];
        this.getPageTotal = res.body.total;
      }else{
        this.tableDataList = [];
        this.getPageTotal = 0;
        this.$Message.error(res.errorMsg);
      }
    }); 
    },
 
  search(){
    this.onSearch(this.form_filter);
  },
  reset() {
    this.form_filter={
      protocol_name:null,
      model_code: null,
      
    };
    this.search();
  },
},
  
mounted() {
  if(this.code){
    this.$set(this.reqBase,'project_code',this.code)
  }
  if(this.reducehe){
    this.reduceheight=this.reducehe
  }else{
     this.init();
  }
},
created() {
  // this.getPageSizeToStorage();
}
}
</script>
<style scoped>
.div2 {
  font-size: 15px;
  text-align: center;
}
.contentBaseRef /deep/ .headerWrapper{
  align-items: center; 
}
.title{background:#fff;width:100%;font-size:15px;font-weight: bold;height:80px;text-indent: 30px;line-height:80px;
  border-top:1px solid #ccc;color:#666; }
</style>
